<template>
  <v-layout justify-space-between align-center class="agree-button">
    <v-flex class="font-weight-bold" :class="{ 'error--text': isError }">
      <ul v-if="prefix">
        <li class="pr-2" :style="`list-style-type: '${prefix}'`">{{ description }}</li>
      </ul>
      <p v-else class="mb-0 pr-2">{{ description }}</p>
    </v-flex>
    <v-flex>
      <v-layout justify-end>
        <v-btn
          ref="button"
          depressed
          height="46"
          :class="{ 'error-btn': isError }"
          @click="$emit('update:isAgree', !isAgree)"
        >
          <b
            class="font-size--13"
            :class="`${isAgree ? 'color--nice' : isError ? 'error--text' : 'color--nice-grey'}`"
          >
            {{ btnText }}
          </b>
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['description', 'btnText', 'isAgree', 'prefix'],
  computed: {
    ...mapState('ui', ['showErrorMode']),
    isError() {
      return this.showErrorMode && !this.isAgree
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.v-btn {
  &:not(.error-btn) {
    border: 1px solid #d7e1ea;
  }
  &.error-btn {
    border: 1px solid $red;
  }

  background-color: white !important;
}

li,
p,
b,
.v-btn {
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
</style>
